import { render, staticRenderFns } from "./ProgramStageCard.vue?vue&type=template&id=644051f0&scoped=true&"
import script from "./ProgramStageCard.vue?vue&type=script&lang=js&"
export * from "./ProgramStageCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStageCard.vue?vue&type=style&index=0&id=644051f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644051f0",
  null
  
)

export default component.exports